import ApiServer from "../ApiServer.ts";
import * as INR from "../INR.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import * as im from "./im_datamanager.ts";
import * as Html from "../util/Html.ts";
import * as Screen from "../lib/Screen.ts";
import Icons from "../svg/Icons.ts";


import musThreadList from "./im_threadlist.mustache";
import musThreadContent from "./im_threadcontent.mustache";
import musMessages from "./im_messages.mustache";


import * as actionMenu from "../widget/action-menu-registry.ts"
import * as segment from "../tracking-segment.ts";

actionMenu.register({
  imthreadmenu(){
    return {
      menu:[
        {svg:Icons.ic_refresh,onclick:'imrefresh',i18nkey:'im.refresh'},
        {svg:Icons.ic_delete,color:'var(--red)',onclick:'deletethread',i18nkey:'im.deletethread'}
      ]
    };
  }
});



  ApiServer["custom.imsendmessage"] = function(form,success,error){
    //read before the modal is closed. The members picked plus the sender
    const memberCount = ((form.elements.namedItem('to') as HTMLSelectElement)?.selectedOptions?.length || 0) + 1;
    ApiServer.imsend(form,function(this: any, ...args){
      segment.track("Conversation Created",{member_count:memberCount});
      return success?.apply(this,args);
    },error);
    modal.closeDomModal();
  };


  function displayList(threads){
    Html.setHtml(document.getElementById('thread-list'),musThreadList,{threads:threads});
    if(threads.length===0){
      const threadPaneImg = document.querySelector("#thread-pane img") as HTMLElement;
      if(threadPaneImg){
        threadPaneImg.style.display = '';
      }
    }
  }
  var
    layoutDisplayed = false;

  INR.onPage(INR.URL.IM,async function(){
    layoutDisplayed = false;
    INR.subscribe("familyMemberSelected", async function(event){

      await Html.wait(function(){return layoutDisplayed})
      var threadId = im.withparticipant(event.selected)
      if(threadId){
        segment.track("Conversation Opened");
        showthread(threadId,true);
      }else{
        Html.trigger(null,"writeto",[event.selected]);
      }


    });
    INR.subscribe("handleParam", function(event){
      showthread(libLocation.getURLParam('threadId'),false);
      var target = libLocation.getURLParam('target');
      if(target){
        amplify.publish("familyMemberSelected",{selected:target})
      }
    })


    var threads = await im.withallthread(true)
    displayList(threads);

    if(!Screen.isMobileView()){
      const firstThread = document.querySelector("#thread-list .fw-thread[data-fw-onclick]") as HTMLElement;
      if(firstThread){
        //not through click(): an automatic selection is not a "Conversation Opened"
        showthread(Html.getDomMetaId(firstThread),false);
      }
    }
    layoutDisplayed = true;
    amplify.publish("handleParam")

  });

  function hilightThreadSelector(threadId){
    document.querySelectorAll('.fw-thread.selected').forEach(el => el.classList.remove('selected'));
    const threadLink = document.querySelector(`.fw-thread[data-fw-meta-id='${threadId}']`) as HTMLElement;
    if(threadLink){
      threadLink.classList.add('selected');
      const notification = threadLink.querySelector('.fw-notification') as HTMLElement;
      if(notification){
        notification.style.display = 'none';
      }
    }
  }

  async function showthread(threadId :string,focus :boolean, refresh = false){
    if(!threadId){
      const threadPane = document.getElementById("thread-pane");
      if(threadPane){
        threadPane.classList.remove('open');
      }
      return;
    }
    const thread = await im.withfullthread(threadId,refresh)
    displayThreadInHtml(thread,focus)

  }
  function displayThreadInHtml(thread, focus=false){
      hilightThreadSelector(thread.metaId);
      const thePane = document.getElementById("thread-pane")!;
      thePane.classList.add('open');
      Html.setHtml(thePane,musThreadContent,thread);
      setTimeout(()=>{
        const container = document.getElementById("immessage-container");
        if(container?.lastElementChild){
          container.lastElementChild.scrollIntoView();
        }
      },10);
      if(focus){
        document.querySelector<HTMLTextAreaElement>("#thread-pane textarea")?.focus();
      }
      const messageContainer = document.getElementById("immessage-container") as HTMLElement;
      messageContainer.addEventListener('afterupdate',function(this:HTMLElement, evt){
        var delta = (evt as CustomEvent).detail
        this.scrollTop =  this.scrollTop+ delta;
      });
      if(thread.isunRead()){
        thread.markAsRead();
        ApiServer.immarkasread(thread.metaId);
        amplify.publish("notificationBulletDelta","imunreadthread",-1);
      }
  }

  function refreshThreadMessages(threadId){
    showthread(threadId,false,true)
  }
  amplify.subscribe("messageSent",async function(message){
    segment.track("Message Sent");
    const mediaType = message?.giphy?.length ? 'gif'
      : message?.gallery?.pictures?.length ? 'image'
      : message?.gallery?.videos?.length ? 'video'
      : message?.gallery?.audios?.length ? 'audio' : undefined;
    if(mediaType){
      segment.track("Message Media Attached",{media_type:mediaType});
    }
    var threads = await im.withallthread(false)
    displayList(threads);
    showthread(message.threadId||message.threadUsersToken,true);


  });
  amplify.subscribe("mediaDeleted",function(mediaId){
    document.querySelectorAll(`*[data-fw-meta-id="${mediaId}"]`).forEach(el=>el.remove())
  });

Html.registerDom({
  async writeto(targetId :string){
    var
      proto = function(){},
      familyWithoutMe = new proto(),
      recipients = Array.from(arguments).map(function(o){return String(o);});

    proto.prototype = FwDatas.getFamily();
    familyWithoutMe.members = FwDatas.getFamily().members.filter(member=>{
      return (member.accountId !== FwDatas.getAccountId());
    });

    if(familyWithoutMe.members.length===0){
      await modal.alert("errors.familyEmpty");
      Html.trigger(null,'invite');
    } else {
      var threadId = im.withparticipant(targetId)
      if(threadId){
        segment.track("Conversation Opened");
        showthread(threadId,true);
      }else{
        var TPL = await import("../modal/new_message.mustache")
        modal.openDomModal(TPL,{accountid:recipients||"all",familyWithoutMe:familyWithoutMe});
      }

    }
  },
  async deletethread(){
    const metaId = Html.getDomMetaId(this);
    if(!await modal.confirmDelete("im.confirmdeletethread")) return;

    await ApiServer.metadelete(metaId);
    libLocation.refresh()
  },
  async imloadolder(threadId,nextPageId){
    const thread = await im.withOlderMessages(threadId,nextPageId)
    const nextNode = this.nextElementSibling as HTMLElement;
    Html.setHtmlAtStart(this.parentElement!,musMessages,thread);
    this.remove();
    if(nextNode?.previousElementSibling){
      (nextNode.previousElementSibling as HTMLElement).scrollIntoView();
    }
  },
  showthread(threadId){
    //a thread picked in the list. Deep links (?threadId=) and the desktop auto-selection are not tracked
    segment.track("Conversation Opened");
    if(Screen.isMobileView()){
      libLocation.goTo("?threadId="+threadId);
    }else{
      showthread(threadId,false)
    }

  },
  async imrefresh(){
    const currentThreadId = Html.getDomMetaId(this);
    var threads = await im.withallthread(false)
    displayList(threads);
    hilightThreadSelector(currentThreadId);
    refreshThreadMessages(currentThreadId);

  }

});